import { IColumnModel } from './../../../models/doview/column.model';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';
import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { MultiSelect } from 'primeng/multiselect';

@Component({
  selector: 'app-do-column-show-hide',
  standalone: false,
  templateUrl: './do-column-show-hide.component.html',
  styleUrl: './do-column-show-hide.component.scss',
})
export class DoColumnShowHideComponent extends BaseComponent implements OnInit {
  @ViewChild('multiselect') multiselect!: MultiSelect;
  @ViewChild('columnButton', { read: ElementRef }) columnButton!: ElementRef;

  columns: IColumnModel[] = [];
  selectedColumns: IColumnModel[] = [];

  constructor(
    private toolbarEventManagerHelper: ToolbarEventManagerHelper,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribers.doTableColumns = this.toolbarEventManagerHelper.$DoTableColumns.subscribe((cols: IColumnModel[]) => {
      if (cols && cols.length > 0) {
        // Filter columns to only show those with isHideToggle = true
        this.columns = cols.filter((col) => col.isToggleColumn);
        // Initialize selected columns with visible ones that can be toggled
        this.selectedColumns = this.columns.filter((col) => col.isVisible !== false);
        this.cdr.detectChanges();
      }
    });
  }

  toggleMultiselect(event: Event): void {
    if (this.multiselect) {
      this.multiselect.show();
    }
  }

  onSelectionChange(): void {
    // Update visibility for all columns based on selection
    this.columns.forEach((col) => {
      const isSelected = this.selectedColumns.some((selectedCol) => selectedCol.fieldName === col.fieldName);
      const visibilityChanged = col.isVisible !== isSelected;

      if (visibilityChanged) {
        col.isVisible = isSelected;
        console.log(col);
        this.toolbarEventManagerHelper.DoColumnToggle = col;
      }
    });
  }
}
